/**
 * The flag in `enabledFeatureFlags` with which a portal reads the member profile at the leerplatform instead of
 * AcademyDepartments, which passed it on from learning-academy. A portal without an academy site (ADR 0014) needs it.
 */
export const PROFILE_IN_LEERPLATFORM = 'profileInLeerplatform';

/**
 * The base url of the member profile read (`GET api/1.0/profile`): the leerplatform once the portal has the flag, where
 * the portal is the tenant of the request, AcademyDepartments until then, where it is part of the route. The response
 * has the same shape on both. Set once in the settings (`minervaSettingsSaga`); screens use `profileUrl`.
 */
export const profileApiUrl = (settings) =>
    settings.enabledFeatureFlags?.[PROFILE_IN_LEERPLATFORM]
        ? settings.apiUrl && `${settings.apiUrl}/api/1.0/profile`
        : settings.academyDepartmentsUrl &&
          settings.portalIdentifier &&
          `${settings.academyDepartmentsUrl}/api/1.0/profile/${settings.portalIdentifier}`;

/**
 * The member profile read of `idString`. Undefined while the settings or the idString are missing, so a screen does not
 * request before the settings are in.
 */
export const profileUrl = (settings, idString) =>
    settings?.profileApiUrl && idString
        ? `${settings.profileApiUrl}?idString=${encodeURIComponent(idString)}`
        : undefined;

/**
 * The member profile write (`PUT api/1.0/profile/{portal}`): still AcademyDepartments for every portal, until the write
 * is at the leerplatform too.
 */
export const profileWriteUrl = (settings, idString) =>
    settings?.academyDepartmentsUrl && settings.portalIdentifier && idString
        ? `${settings.academyDepartmentsUrl}/api/1.0/profile/${settings.portalIdentifier}?idString=${encodeURIComponent(idString)}`
        : undefined;
